import BorrowCell from '@/components/Reports/Cell/BorrowCell.vue'

const config = {
  cellRenderer: BorrowCell
}
export default {
  type: 'Borrow',
  config
}
